// This file is @generated - manual changes will be lost.
export const fallbackAutoGenerated = {
  'moneyIn.voucher.Afvigelse.title': 'Afvigelse',
  'moneyIn.voucher.AggregatedPersonSpecVoucher.title':
    'Aggregated person spec voucher',
  'moneyIn.voucher.AmountWithPeriod.title': 'Amount with period',
  'moneyIn.voucher.AssumedMoneyInPolicySpecification.title':
    'Assumed money in policy specification',
  'moneyIn.voucher.AssumedPaymentInvoiceElementVoucher.title':
    'Assumed payment invoice element voucher',
  'moneyIn.voucher.AssumedPaymentInvoiceSpecification.title':
    'Assumed payment invoice specification',
  'moneyIn.voucher.AzlPreliminaryPremiumVoucher.title':
    'Azl preliminary premium voucher',
  'moneyIn.voucher.AzlReturnPaymentInvoiceSpecification.title':
    'Azl return payment invoice specification',
  'moneyIn.voucher.AzlReturnPaymentInvoiceVoucher.title':
    'Azl return payment invoice voucher',
  'moneyIn.voucher.BeskGrad.title': 'Besk grad',
  'moneyIn.voucher.BillingPaymentSpecVoucher.title':
    'Billing payment spec voucher',
  'moneyIn.voucher.BillingRequestInvoiceSpecification.title':
    'Billing request invoice specification',
  'moneyIn.voucher.BillingRequestSpecification.title':
    'Billing request specification',
  'moneyIn.voucher.BillingRequestVoucher.title': 'Billing request voucher',
  'moneyIn.voucher.BillingVoucher.title': 'Billing voucher',
  'moneyIn.voucher.BlobRef.title': 'Blob ref',
  'moneyIn.voucher.Bs601BillingVoucher.title': 'Bs601 billing voucher',
  'moneyIn.voucher.Bs602BillingPaymentSpecVoucher.title':
    'Bs602 billing payment spec voucher',
  'moneyIn.voucher.Bs602PaymentVoucher.title': 'Bs602 payment voucher',
  'moneyIn.voucher.CancelledBillingRequestVoucher.title':
    'Cancelled billing request voucher',
  'moneyIn.voucher.CancelledInvoicePaymentVoucher.title':
    'Cancelled invoice payment voucher',
  'moneyIn.voucher.CommonEmploymentInformation.title':
    'Common employment information',
  'moneyIn.voucher.CompanyRef.title': 'Company ref',
  'moneyIn.voucher.CorporatePaymentOrigin.title': 'Corporate payment origin',
  'moneyIn.voucher.CorporatePersonSpec.title': 'Corporate person spec',
  'moneyIn.voucher.CorporateSpecSourceInformation.title':
    'Corporate spec source information',
  'moneyIn.voucher.CorporateSpecificationLineVoucher.title':
    'Corporate specification line voucher',
  'moneyIn.voucher.DailyWage.title': 'Daily wage',
  'moneyIn.voucher.DirectDebitPaymentCancellationVoucher.title':
    'Direct debit payment cancellation voucher',
  'moneyIn.voucher.DirectDebitPaymentSpecVoucher.title':
    'Direct debit payment spec voucher',
  'moneyIn.voucher.DirectDebitPaymentVoucher.title':
    'Direct debit payment voucher',
  'moneyIn.voucher.DocumentRef.title': 'Document ref',
  'moneyIn.voucher.EfakturaPaymentVoucher.title': 'Efaktura payment voucher',
  'moneyIn.voucher.EmployeeData.title': 'Employee data',
  'moneyIn.voucher.EmployeePremiumVoucher.title': 'Employee premium voucher',
  'moneyIn.voucher.EmployerAgreementData.title': 'Employer agreement data',
  'moneyIn.voucher.EmployerInvoiceSpecification.title':
    'Employer invoice specification',
  'moneyIn.voucher.EmployerSpecVoucher.title': 'Employer spec voucher',
  'moneyIn.voucher.EmploymentContributionSpec.title':
    'Employment contribution spec',
  'moneyIn.voucher.EmploymentData.title': 'Employment data',
  'moneyIn.voucher.EmploymentDataCancellation.title':
    'Employment data cancellation',
  'moneyIn.voucher.EmploymentDataCancellationVoucher.title':
    'Employment data cancellation voucher',
  'moneyIn.voucher.EmploymentVoucher.title': 'Employment voucher',
  'moneyIn.voucher.ExternalInvoiceElementVoucher.title':
    'External invoice element voucher',
  'moneyIn.voucher.ExternalInvoiceSpecification.title':
    'External invoice specification',
  'moneyIn.voucher.ExternalPayloadOrigin.title': 'External payload origin',
  'moneyIn.voucher.ExternalPayloadSourceData.title':
    'External payload source data',
  'moneyIn.voucher.ExternalPaymentLineData.title': 'External payment line data',
  'moneyIn.voucher.IN00500Line.title': 'In00500 line',
  'moneyIn.voucher.IncomingValueTransferPaymentVoucher.title':
    'Incoming value transfer payment voucher',
  'moneyIn.voucher.IncomingValueTransferVoucher.title':
    'Incoming value transfer voucher',
  'moneyIn.voucher.InfoServiceFileMetrics.title': 'Info service file metrics',
  'moneyIn.voucher.InfoServiceLineVoucher.title': 'Info service line voucher',
  'moneyIn.voucher.InfoServicePaymentVoucher.title':
    'Info service payment voucher',
  'moneyIn.voucher.InfoserviceCorporateSpec.title':
    'Infoservice corporate spec',
  'moneyIn.voucher.InstallmentPlanInvoiceElementVoucher.title':
    'Installment plan invoice element voucher',
  'moneyIn.voucher.InstallmentPlanInvoiceReference.title':
    'Installment plan invoice reference',
  'moneyIn.voucher.InstallmentPlanInvoiceSpecification.title':
    'Installment plan invoice specification',
  'moneyIn.voucher.InvoiceBundlingPenaltyVoucher.title':
    'Invoice bundling penalty voucher',
  'moneyIn.voucher.InvoiceElementVoucher.title': 'Invoice element voucher',
  'moneyIn.voucher.InvoicePaymentOrigin.title': 'Invoice payment origin',
  'moneyIn.voucher.InvoicePaymentVoucher.title': 'Invoice payment voucher',
  'moneyIn.voucher.InvoicePenaltyVoucher.title': 'Invoice penalty voucher',
  'moneyIn.voucher.InvoiceSpecification.title': 'Invoice specification',
  'moneyIn.voucher.LeaveInformation.title': 'Leave information',
  'moneyIn.voucher.LegalEntityRef.title': 'Legal entity ref',
  'moneyIn.voucher.ManualExternalInvoiceElementVoucher.title':
    'Manual external invoice element voucher',
  'moneyIn.voucher.ManualInvoice.title': 'Manual invoice',
  'moneyIn.voucher.ManualInvoiceDetail.title': 'Manual invoice detail',
  'moneyIn.voucher.ManualInvoiceSpecification.title':
    'Manual invoice specification',
  'moneyIn.voucher.ManualPaymentSpecOrigin.title': 'Manual payment spec origin',
  'moneyIn.voucher.ManualPaymentVoucher.title': 'Manual payment voucher',
  'moneyIn.voucher.MigratedInvoice.title': 'Migrated invoice',
  'moneyIn.voucher.MigratedInvoiceSpecification.title':
    'Migrated invoice specification',
  'moneyIn.voucher.MoneyInVoucher.title': 'Money in voucher',
  'moneyIn.voucher.NaturalPerson.title': 'Natural person',
  'moneyIn.voucher.NetAxeptBatch.title': 'Net axept batch',
  'moneyIn.voucher.NetAxeptBatchData.title': 'Net axept batch data',
  'moneyIn.voucher.NetAxeptPaymentVoucher.title': 'Net axept payment voucher',
  'moneyIn.voucher.NetAxeptVoucher.title': 'Net axept voucher',
  'moneyIn.voucher.NlBillingVoucher.title': 'Nl billing voucher',
  'moneyIn.voucher.NlValueTransferStatement.title':
    'Nl value transfer statement',
  'moneyIn.voucher.NormBidrag.title': 'Norm bidrag',
  'moneyIn.voucher.OutgoingBillingSpecification.title':
    'Outgoing billing specification',
  'moneyIn.voucher.P41AmountEntity.title': 'P41 amount entity',
  'moneyIn.voucher.P41BankAccount.title': 'P41 bank account',
  'moneyIn.voucher.P41BankAdditionalPaymentInfo.title':
    'P41 bank additional payment info',
  'moneyIn.voucher.P41BankDataCommon.title': 'P41 bank data common',
  'moneyIn.voucher.P41BankPALTax31.title': 'P41 bank paltax31',
  'moneyIn.voucher.P41BankPALTax32.title': 'P41 bank paltax32',
  'moneyIn.voucher.P41BankPALTax33.title': 'P41 bank paltax33',
  'moneyIn.voucher.P41BankPALTax34.title': 'P41 bank paltax34',
  'moneyIn.voucher.P41BankPaymentInformation.title':
    'P41 bank payment information',
  'moneyIn.voucher.P41BankPaymentRemark.title': 'P41 bank payment remark',
  'moneyIn.voucher.P41BankTransferData.title': 'P41 bank transfer data',
  'moneyIn.voucher.P41BankTransferData34.title': 'P41 bank transfer data34',
  'moneyIn.voucher.P41BankTransferFromBankV2_3.title':
    'P41 bank transfer from bank v2_3',
  'moneyIn.voucher.P41BankTransferFromBankWithTax1V2_3.title':
    'P41 bank transfer from bank with tax1 v2_3',
  'moneyIn.voucher.P41BankTransferFromPensionV2_3.title':
    'P41 bank transfer from pension v2_3',
  'moneyIn.voucher.P41BankTransferFromPensionWithTax1V2_3.title':
    'P41 bank transfer from pension with tax1 v2_3',
  'moneyIn.voucher.P41BankTransferV2_3.title': 'P41 bank transfer v2_3',
  'moneyIn.voucher.P41ContactPerson.title': 'P41 contact person',
  'moneyIn.voucher.P41EmbeddedDocument.title': 'P41 embedded document',
  'moneyIn.voucher.P41OngoingAgeSchemePayments.title':
    'P41 ongoing age scheme payments',
  'moneyIn.voucher.P41OngoingInstalmentPensionPayments.title':
    'P41 ongoing instalment pension payments',
  'moneyIn.voucher.P41OngoingLifetimeAnnuityPayments.title':
    'P41 ongoing lifetime annuity payments',
  'moneyIn.voucher.P41OngoingPaymentsType.title': 'P41 ongoing payments type',
  'moneyIn.voucher.P41OngoingStoppingAnnuityPayments.title':
    'P41 ongoing stopping annuity payments',
  'moneyIn.voucher.P41PaymentAgeType.title': 'P41 payment age type',
  'moneyIn.voucher.P41PaymentInformation.title': 'P41 payment information',
  'moneyIn.voucher.P41PaymentSpecVoucher.title': 'P41 payment spec voucher',
  'moneyIn.voucher.P41PaymentVoucher.title': 'P41 payment voucher',
  'moneyIn.voucher.P41PensionPALTax.title': 'P41 pension paltax',
  'moneyIn.voucher.P41PensionPaymentInformation.title':
    'P41 pension payment information',
  'moneyIn.voucher.P41PensionPrivateTransferV3_5.title':
    'P41 pension private transfer v3_5',
  'moneyIn.voucher.P41PensionProfessionalTransferV3_5.title':
    'P41 pension professional transfer v3_5',
  'moneyIn.voucher.P41PensionTransferV3_5.title': 'P41 pension transfer v3_5',
  'moneyIn.voucher.P41Repurchase.title': 'P41 repurchase',
  'moneyIn.voucher.P41SpousePension.title': 'P41 spouse pension',
  'moneyIn.voucher.P41SuppAmountEntity.title': 'P41 supp amount entity',
  'moneyIn.voucher.P41ToBankV2_3.title': 'P41 to bank v2_3',
  'moneyIn.voucher.P41Transfer.title': 'P41 transfer',
  'moneyIn.voucher.P41TrivialityAdjustmentVoucher.title':
    'P41 triviality adjustment voucher',
  'moneyIn.voucher.PaidInvoiceVoucher.title': 'Paid invoice voucher',
  'moneyIn.voucher.PartIdentification.title': 'Part identification',
  'moneyIn.voucher.PaymentOrigin.title': 'Payment origin',
  'moneyIn.voucher.PaymentSender.title': 'Payment sender',
  'moneyIn.voucher.PaymentSpecOrigin.title': 'Payment spec origin',
  'moneyIn.voucher.PaymentSpecSubVoucher.title': 'Payment spec sub voucher',
  'moneyIn.voucher.PaymentSpecVoucher.title': 'Payment spec voucher',
  'moneyIn.voucher.PaymentVoucher.title': 'Payment voucher',
  'moneyIn.voucher.PenaltyVoucher.title': 'Penalty voucher',
  'moneyIn.voucher.PensionProviderPaymentOrigin.title':
    'Pension provider payment origin',
  'moneyIn.voucher.PensionTransferVoucher.title': 'Pension transfer voucher',
  'moneyIn.voucher.PersonRef.title': 'Person ref',
  'moneyIn.voucher.PersonSpecVoucher.title': 'Person spec voucher',
  'moneyIn.voucher.PremiumCalculationPenaltyVoucher.title':
    'Premium calculation penalty voucher',
  'moneyIn.voucher.PremiumExternalInvoiceElementVoucher.title':
    'Premium external invoice element voucher',
  'moneyIn.voucher.PremiumInvoiceDetail.title': 'Premium invoice detail',
  'moneyIn.voucher.PrivateBillingInvoiceElementVoucher.title':
    'Private billing invoice element voucher',
  'moneyIn.voucher.PrivatePaidBillingVoucher.title':
    'Private paid billing voucher',
  'moneyIn.voucher.PrivatePaymentOrigin.title': 'Private payment origin',
  'moneyIn.voucher.ReminderFeeVoucher.title': 'Reminder fee voucher',
  'moneyIn.voucher.ReturnedPaymentVoucher.title': 'Returned payment voucher',
  'moneyIn.voucher.SalaryInformation.title': 'Salary information',
  'moneyIn.voucher.SenderAccount.title': 'Sender account',
  'moneyIn.voucher.SenderAccountIban.title': 'Sender account iban',
  'moneyIn.voucher.SenderAccountOther.title': 'Sender account other',
  'moneyIn.voucher.TelephoneNumber.title': 'Telephone number',
  'moneyIn.voucher.TransitContributionOutVoucher.title':
    'Transit contribution out voucher',
  'moneyIn.voucher.TransitCorporateSpecificationLineVoucher.title':
    'Transit corporate specification line voucher',
  'moneyIn.voucher.TwkInvoice.title': 'Twk invoice',
  'moneyIn.voucher.TwkInvoiceSpecification.title': 'Twk invoice specification',
  'moneyIn.voucher.UnexpectedDistributedInvoicePaymentVoucher.title':
    'Unexpected distributed invoice payment voucher',
  'moneyIn.voucher.UnexpectedInvoicePaymentVoucher.title':
    'Unexpected invoice payment voucher',
  'moneyIn.voucher.UnexpectedPaymentVoucher.title':
    'Unexpected payment voucher',
  'moneyIn.voucher.UnrelatedPaymentVoucher.title': 'Unrelated payment voucher',
  'moneyIn.voucher.UpaIncomeRelation.title': 'Upa income relation',
  'moneyIn.voucher.UpaIncomeRelationDeclarationValidationResult.title':
    'Upa income relation declaration validation result',
  'moneyIn.voucher.UpaIncomeRelationDeclarationValidationResultV2.title':
    'Upa income relation declaration validation result v2',
  'moneyIn.voucher.UpaIncomeRelationVoucher.title':
    'Upa income relation voucher',
  'moneyIn.voucher.UpaIncomeRelationVoucherV2.title':
    'Upa income relation voucher v2',
  'moneyIn.voucher.UpaIncomeRelationWithdrawalVoucher.title':
    'Upa income relation withdrawal voucher',
  'moneyIn.voucher.UpaIncomeRelationWithdrawalVoucherV2.title':
    'Upa income relation withdrawal voucher v2',
  'moneyIn.voucher.UpaMessageValidationResult.title':
    'Upa message validation result',
  'moneyIn.voucher.UpaMessageValidationResultV2.title':
    'Upa message validation result v2',
  'moneyIn.voucher.UpaValidationVoucher.title': 'Upa validation voucher',
  'moneyIn.voucher.UpaVoucher.title': 'Upa voucher',
  'moneyIn.voucher.UpaVoucherV2.title': 'Upa voucher v2',
  'moneyIn.voucher.ValueTransferAutomaticPaymentVoucher.title':
    'Value transfer automatic payment voucher',
  'moneyIn.voucher.ValueTransferStatement.title': 'Value transfer statement',
  'moneyIn.voucher.VoluntaryContributionVoucher.title':
    'Voluntary contribution voucher',
  'moneyIn.voucher.WithdrawnContributionVoucher.title':
    'Withdrawn contribution voucher',
  'moneyIn.voucher.WriteOffInvoicePaymentVoucher.title':
    'Write off invoice payment voucher',
  'moneyIn.voucher._id': '_id',
  'moneyIn.voucher.absoluteAmount': 'Absolute amount',
  'moneyIn.voucher.accountNumber': 'Account number',
  'moneyIn.voucher.accruedRightHolidayAllowance':
    'Accrued right holiday allowance',
  'moneyIn.voucher.acqRefDataVar': 'Acq ref data var',
  'moneyIn.voucher.additionalInformation': 'Additional information',
  'moneyIn.voucher.additionalPaymentInfo': 'Additional payment info',
  'moneyIn.voucher.advNo': 'Adv no',
  'moneyIn.voucher.afsAftNrHosModt': 'Afs aft nr hos modt',
  'moneyIn.voucher.afvigelse': 'Afvigelse',
  'moneyIn.voucher.afvigelseDto': 'Afvigelse dto',
  'moneyIn.voucher.afvigelseKod': 'Afvigelse kod',
  'moneyIn.voucher.afvigelsesBlb': 'Afvigelses blb',
  'moneyIn.voucher.afvigelsesFrtflt': 'Afvigelses frtflt',
  'moneyIn.voucher.afvigelsesPct': 'Afvigelses pct',
  'moneyIn.voucher.aggregationLineId': 'Aggregation line id',
  'moneyIn.voucher.agreementId': 'Agreement id',
  'moneyIn.voucher.agreementQualifier': 'Agreement qualifier',
  'moneyIn.voucher.amount': 'Amount',
  'moneyIn.voucher.amountEntity': 'Amount entity',
  'moneyIn.voucher.amountOriginal': 'Amount original',
  'moneyIn.voucher.amountPenalties': 'Amount penalties',
  'moneyIn.voucher.amountPenaltiesTwk': 'Amount penalties twk',
  'moneyIn.voucher.amountRegularPremium': 'Amount regular premium',
  'moneyIn.voucher.amountSettlement': 'Amount settlement',
  'moneyIn.voucher.amountTwkPremium': 'Amount twk premium',
  'moneyIn.voucher.arbAndelBidragBlb': 'Arb andel bidrag blb',
  'moneyIn.voucher.arbAndelPensBidragPct': 'Arb andel pens bidrag pct',
  'moneyIn.voucher.args': 'Args',
  'moneyIn.voucher.assetManagementCost': 'Asset management cost',
  'moneyIn.voucher.assetManagementCostOngoingAgeScheme_Bank':
    'Asset management cost ongoing age scheme_bank',
  'moneyIn.voucher.assetManagementCostTaxCode1B_Bank':
    'Asset management cost tax code1 b_bank',
  'moneyIn.voucher.assetManagementCostTaxCode1and2_Bank':
    'Asset management cost tax code1and2_bank',
  'moneyIn.voucher.assetManagementCostTaxCode2B_Bank':
    'Asset management cost tax code2 b_bank',
  'moneyIn.voucher.assetManagementCostTaxCode3A_Bank':
    'Asset management cost tax code3 a_bank',
  'moneyIn.voucher.assetManagementCostTaxCode3B_Bank':
    'Asset management cost tax code3 b_bank',
  'moneyIn.voucher.assetManagementCostTaxfreeAgeScheme_Bank':
    'Asset management cost taxfree age scheme_bank',
  'moneyIn.voucher.assumedMoneyInCoverSpecifications':
    'Assumed money in cover specifications',
  'moneyIn.voucher.assumedMoneyInId': 'Assumed money in id',
  'moneyIn.voucher.assumedMoneyInPolicySpecification':
    'Assumed money in policy specification',
  'moneyIn.voucher.assumedPaymentInvoiceSpecificationEntries':
    'Assumed payment invoice specification entries',
  'moneyIn.voucher.attachedTaxExemption': 'Attached tax exemption',
  'moneyIn.voucher.availStatementFromEmployerWithId':
    'Avail statement from employer with id',
  'moneyIn.voucher.bankAccountKind': 'Bank account kind',
  'moneyIn.voucher.bankRegistrationNumber': 'Bank registration number',
  'moneyIn.voucher.baseAmount': 'Base amount',
  'moneyIn.voucher.baseInvoiceId': 'Base invoice id',
  'moneyIn.voucher.batchData': 'Batch data',
  'moneyIn.voucher.batchId': 'Batch id',
  'moneyIn.voucher.batchNumber': 'Batch number',
  'moneyIn.voucher.batchPaymentId': 'Batch payment id',
  'moneyIn.voucher.beskGrad': 'Besk grad',
  'moneyIn.voucher.beskGradAnt': 'Besk grad ant',
  'moneyIn.voucher.beskGradNvn': 'Besk grad nvn',
  'moneyIn.voucher.beskGradStartDto': 'Besk grad start dto',
  'moneyIn.voucher.beskGradTel': 'Besk grad tel',
  'moneyIn.voucher.billingChannel': 'Billing channel',
  'moneyIn.voucher.billingFrequency': 'Billing frequency',
  'moneyIn.voucher.billingLegalEntityId': 'Billing legal entity id',
  'moneyIn.voucher.billingRequestEntries': 'Billing request entries',
  'moneyIn.voucher.billingRequestId': 'Billing request id',
  'moneyIn.voucher.billingRequestSpecification':
    'Billing request specification',
  'moneyIn.voucher.billingRequestSpecifications':
    'Billing request specifications',
  'moneyIn.voucher.billingText': 'Billing text',
  'moneyIn.voucher.billingVoucher': 'Billing voucher',
  'moneyIn.voucher.birthDate': 'Birth date',
  'moneyIn.voucher.blanks': 'Blanks',
  'moneyIn.voucher.blobName': 'Blob name',
  'moneyIn.voucher.blobRef': 'Blob ref',
  'moneyIn.voucher.blockedInMoneyIn': 'Blocked in money in',
  'moneyIn.voucher.bookDate': 'Book date',
  'moneyIn.voucher.bs602BillingType': 'Bs602 billing type',
  'moneyIn.voucher.buildUpEmploymentTermsAmount':
    'Build up employment terms amount',
  'moneyIn.voucher.bundleDueDate': 'Bundle due date',
  'moneyIn.voucher.bundlePeriodFromDate': 'Bundle period from date',
  'moneyIn.voucher.calculationDate': 'Calculation date',
  'moneyIn.voucher.cancellationDate': 'Cancellation date',
  'moneyIn.voucher.cancellationPaymentId': 'Cancellation payment id',
  'moneyIn.voucher.cancellationReason': 'Cancellation reason',
  'moneyIn.voucher.cancellations': 'Cancellations',
  'moneyIn.voucher.cardAcptTermId': 'Card acpt term id',
  'moneyIn.voucher.cardNameLogo': 'Card name logo',
  'moneyIn.voucher.cardOrganisation': 'Card organisation',
  'moneyIn.voucher.caseNo': 'Case no',
  'moneyIn.voucher.category': 'Category',
  'moneyIn.voucher.cedingCompany': 'Ceding company',
  'moneyIn.voucher.changeDate': 'Change date',
  'moneyIn.voucher.code': 'Code',
  'moneyIn.voucher.codeCollectiveWorkAgreement':
    'Code collective work agreement',
  'moneyIn.voucher.codeIncidentalIncomeReduction':
    'Code incidental income reduction',
  'moneyIn.voucher.codeIncomeRelationType': 'Code income relation type',
  'moneyIn.voucher.codeInfluenceInsuranceObligation':
    'Code influence insurance obligation',
  'moneyIn.voucher.codeLeaveType': 'Code leave type',
  'moneyIn.voucher.codeNatureOfEmploymentRelationship':
    'Code nature of employment relationship',
  'moneyIn.voucher.codePhaseDivision': 'Code phase division',
  'moneyIn.voucher.codeProfession': 'Code profession',
  'moneyIn.voucher.codeReasonForTerminationOfEmployment':
    'Code reason for termination of employment',
  'moneyIn.voucher.codeSpecialIncomeRatio': 'Code special income ratio',
  'moneyIn.voucher.collectiveAgreement': 'Collective agreement',
  'moneyIn.voucher.collectiveAgreementId': 'Collective agreement id',
  'moneyIn.voucher.commission': 'Commission',
  'moneyIn.voucher.commitmentId': 'Commitment id',
  'moneyIn.voucher.commitmentOwner': 'Commitment owner',
  'moneyIn.voucher.commitmentOwnerLegalEntityId':
    'Commitment owner legal entity id',
  'moneyIn.voucher.commonEmploymentInformation':
    'Common employment information',
  'moneyIn.voucher.companyId': 'Company id',
  'moneyIn.voucher.component': 'Component',
  'moneyIn.voucher.contactName': 'Contact name',
  'moneyIn.voucher.contactPhoneNo': 'Contact phone no',
  'moneyIn.voucher.contractHoursPerWeek': 'Contract hours per week',
  'moneyIn.voucher.contributingElements': 'Contributing elements',
  'moneyIn.voucher.contributionCode': 'Contribution code',
  'moneyIn.voucher.contributionId': 'Contribution id',
  'moneyIn.voucher.contributionOptionality': 'Contribution optionality',
  'moneyIn.voucher.contributionPartId': 'Contribution part id',
  'moneyIn.voucher.contributionParts': 'Contribution parts',
  'moneyIn.voucher.contributionVouchersRefs': 'Contribution vouchers refs',
  'moneyIn.voucher.corporatePersonSpec': 'Corporate person spec',
  'moneyIn.voucher.corporateSpecSourceInformation':
    'Corporate spec source information',
  'moneyIn.voucher.corporateSpecificationLineVouchers':
    'Corporate specification line vouchers',
  'moneyIn.voucher.countingIndication': 'Counting indication',
  'moneyIn.voucher.cover': 'Cover',
  'moneyIn.voucher.coverDescription': 'Cover description',
  'moneyIn.voucher.coverInternalTemplateId': 'Cover internal template id',
  'moneyIn.voucher.coverPeriodEnd': 'Cover period end',
  'moneyIn.voucher.coverPeriodStart': 'Cover period start',
  'moneyIn.voucher.creationStamp': 'Creation stamp',
  'moneyIn.voucher.creationTime': 'Creation time',
  'moneyIn.voucher.creditPaymentIndicator': 'Credit payment indicator',
  'moneyIn.voucher.creditorName': 'Creditor name',
  'moneyIn.voucher.currency': 'Currency',
  'moneyIn.voucher.currencyOriginal': 'Currency original',
  'moneyIn.voucher.currencySettl': 'Currency settl',
  'moneyIn.voucher.custRefNo': 'Cust ref no',
  'moneyIn.voucher.customerCPR': 'Customer cpr',
  'moneyIn.voucher.dailyWage': 'Daily wage',
  'moneyIn.voucher.dateTimeTrn': 'Date time trn',
  'moneyIn.voucher.dateTimeUpaFileCreation': 'Date time upa file creation',
  'moneyIn.voucher.dateTimeUpaFileReceival': 'Date time upa file receival',
  'moneyIn.voucher.daysWorked': 'Days worked',
  'moneyIn.voucher.dbCrCard': 'Db cr card',
  'moneyIn.voucher.dbaName': 'Dba name',
  'moneyIn.voucher.dccAmount': 'Dcc amount',
  'moneyIn.voucher.dccCurrency': 'Dcc currency',
  'moneyIn.voucher.debtorAccountNumber': 'Debtor account number',
  'moneyIn.voucher.debtorCustomerNo': 'Debtor customer no',
  'moneyIn.voucher.debtorName': 'Debtor name',
  'moneyIn.voucher.declarationLineId': 'Declaration line id',
  'moneyIn.voucher.declaredIncomeRelationIds': 'Declared income relation ids',
  'moneyIn.voucher.defaultReceivingCompanyId': 'Default receiving company id',
  'moneyIn.voucher.deliveryDate': 'Delivery date',
  'moneyIn.voucher.deliveryNumber': 'Delivery number',
  'moneyIn.voucher.description': 'Description',
  'moneyIn.voucher.directDebitType': 'Direct debit type',
  'moneyIn.voucher.disableSpecificValidations': 'Disable specific validations',
  'moneyIn.voucher.dlSeNr': 'Dl se nr',
  'moneyIn.voucher.docEncodedFileContent': 'Doc encoded file content',
  'moneyIn.voucher.docFileSize': 'Doc file size',
  'moneyIn.voucher.docFilename': 'Doc filename',
  'moneyIn.voucher.docFilenameExtention': 'Doc filename extention',
  'moneyIn.voucher.docMimeType': 'Doc mime type',
  'moneyIn.voucher.documentFunction': 'Document function',
  'moneyIn.voucher.dueDate': 'Due date',
  'moneyIn.voucher.earliestRetirementAge': 'Earliest retirement age',
  'moneyIn.voucher.ediReference': 'Edi reference',
  'moneyIn.voucher.employeeContributionMandatory':
    'Employee contribution mandatory',
  'moneyIn.voucher.employeeContributionOptional':
    'Employee contribution optional',
  'moneyIn.voucher.employeeContributionOptionalWOPExemption':
    'Employee contribution optional wopexemption',
  'moneyIn.voucher.employeeData': 'Employee data',
  'moneyIn.voucher.employeeId': 'Employee id',
  'moneyIn.voucher.employerAgreementData': 'Employer agreement data',
  'moneyIn.voucher.employerAgreementId': 'Employer agreement id',
  'moneyIn.voucher.employerAgreementPolicyKey': 'Employer agreement policy key',
  'moneyIn.voucher.employerCertification': 'Employer certification',
  'moneyIn.voucher.employerContribution': 'Employer contribution',
  'moneyIn.voucher.employerContributionPercentage':
    'Employer contribution percentage',
  'moneyIn.voucher.employerId': 'Employer id',
  'moneyIn.voucher.employerRef': 'Employer ref',
  'moneyIn.voucher.employerSpecId': 'Employer spec id',
  'moneyIn.voucher.employingCompany': 'Employing company',
  'moneyIn.voucher.employmentCancelled': 'Employment cancelled',
  'moneyIn.voucher.employmentContractforIndefinitePeriod':
    'Employment contractfor indefinite period',
  'moneyIn.voucher.employmentData': 'Employment data',
  'moneyIn.voucher.employmentDataCancellation': 'Employment data cancellation',
  'moneyIn.voucher.employmentEnd': 'Employment end',
  'moneyIn.voucher.employmentId': 'Employment id',
  'moneyIn.voucher.employmentName': 'Employment name',
  'moneyIn.voucher.employmentStart': 'Employment start',
  'moneyIn.voucher.employmentType': 'Employment type',
  'moneyIn.voucher.endDate': 'End date',
  'moneyIn.voucher.endToEndId': 'End to end id',
  'moneyIn.voucher.endingPension': 'Ending pension',
  'moneyIn.voucher.entryType': 'Entry type',
  'moneyIn.voucher.errorCodes': 'Error codes',
  'moneyIn.voucher.errors': 'Errors',
  'moneyIn.voucher.exPartnerValue': 'Ex partner value',
  'moneyIn.voucher.externalEmploymentId': 'External employment id',
  'moneyIn.voucher.externalPayloadKey': 'External payload key',
  'moneyIn.voucher.externalPayloadRegistrationRef':
    'External payload registration ref',
  'moneyIn.voucher.externalPayloadSourceData': 'External payload source data',
  'moneyIn.voucher.externalPayloadType': 'External payload type',
  'moneyIn.voucher.externalPaymentId': 'External payment id',
  'moneyIn.voucher.externalPaymentLineData': 'External payment line data',
  'moneyIn.voucher.externalRef': 'External ref',
  'moneyIn.voucher.externalTransferId': 'External transfer id',
  'moneyIn.voucher.favourInformation': 'Favour information',
  'moneyIn.voucher.fees': 'Fees',
  'moneyIn.voucher.fkMedlemsNr': 'Fk medlems nr',
  'moneyIn.voucher.formerEmployer': 'Former employer',
  'moneyIn.voucher.fromDate': 'From date',
  'moneyIn.voucher.fromDueDate': 'From due date',
  'moneyIn.voucher.fullSalaryInPeriod': 'Full salary in period',
  'moneyIn.voucher.generationScheme': 'Generation scheme',
  'moneyIn.voucher.grossHourlyWage': 'Gross hourly wage',
  'moneyIn.voucher.grossPayment': 'Gross payment',
  'moneyIn.voucher.grossSalary': 'Gross salary',
  'moneyIn.voucher.handlingFee': 'Handling fee',
  'moneyIn.voucher.holidayAllowance': 'Holiday allowance',
  'moneyIn.voucher.hoursOfLeave': 'Hours of leave',
  'moneyIn.voucher.id': 'Id',
  'moneyIn.voucher.identityQualifier': 'Identity qualifier',
  'moneyIn.voucher.identityValue': 'Identity value',
  'moneyIn.voucher.incomePeriods': 'Income periods',
  'moneyIn.voucher.incomeRelationEndDate': 'Income relation end date',
  'moneyIn.voucher.incomeRelationId': 'Income relation id',
  'moneyIn.voucher.incomeRelationStartDate': 'Income relation start date',
  'moneyIn.voucher.incurredBundlingPenaltyIds': 'Incurred bundling penalty ids',
  'moneyIn.voucher.indicationEndOfParticipation':
    'Indication end of participation',
  'moneyIn.voucher.infoServiceFileMetrics': 'Info service file metrics',
  'moneyIn.voucher.infoType': 'Info type',
  'moneyIn.voucher.infotypeKod': 'Infotype kod',
  'moneyIn.voucher.inputDate': 'Input date',
  'moneyIn.voucher.installmentPlanInvoiceReference':
    'Installment plan invoice reference',
  'moneyIn.voucher.installmentPlanInvoiceReferences':
    'Installment plan invoice references',
  'moneyIn.voucher.installmentSpecifications': 'Installment specifications',
  'moneyIn.voucher.insuredLegalEntityId': 'Insured legal entity id',
  'moneyIn.voucher.integrationName': 'Integration name',
  'moneyIn.voucher.interestAmount_Bank': 'Interest amount_bank',
  'moneyIn.voucher.interestPeriodDaysCount': 'Interest period days count',
  'moneyIn.voucher.interestRate': 'Interest rate',
  'moneyIn.voucher.interestStartDate': 'Interest start date',
  'moneyIn.voucher.interestStopDate': 'Interest stop date',
  'moneyIn.voucher.internalReferenceToCustomerPolicy':
    'Internal reference to customer policy',
  'moneyIn.voucher.invoiceBundlingPenaltyType': 'Invoice bundling penalty type',
  'moneyIn.voucher.invoiceDate': 'Invoice date',
  'moneyIn.voucher.invoiceDetails': 'Invoice details',
  'moneyIn.voucher.invoiceId': 'Invoice id',
  'moneyIn.voucher.invoicePayerType': 'Invoice payer type',
  'moneyIn.voucher.invoicePeriodEndDate': 'Invoice period end date',
  'moneyIn.voucher.invoicePeriodStartDate': 'Invoice period start date',
  'moneyIn.voucher.invoiceSourceRef': 'Invoice source ref',
  'moneyIn.voucher.invoiceSpecification': 'Invoice specification',
  'moneyIn.voucher.invoiceStrategyOperationId': 'Invoice strategy operation id',
  'moneyIn.voucher.invoiceType': 'Invoice type',
  'moneyIn.voucher.irregularitySurcharge': 'Irregularity surcharge',
  'moneyIn.voucher.isContributionAfterEmploymentEnd':
    'Is contribution after employment end',
  'moneyIn.voucher.isCustomerPALTaxPayer': 'Is customer paltax payer',
  'moneyIn.voucher.isManualTransfer': 'Is manual transfer',
  'moneyIn.voucher.isPremiumAfterEmploymentEnd':
    'Is premium after employment end',
  'moneyIn.voucher.issuerCountry': 'Issuer country',
  'moneyIn.voucher.jobAgreementRuleJoined': 'Job agreement rule joined',
  'moneyIn.voucher.jobDescription': 'Job description',
  'moneyIn.voucher.keptWidowsPensionRight': 'Kept widows pension right',
  'moneyIn.voucher.key': 'Key',
  'moneyIn.voucher.kundNrHosAfs': 'Kund nr hos afs',
  'moneyIn.voucher.kundNrHosModt': 'Kund nr hos modt',
  'moneyIn.voucher.kundStartDato': 'Kund start dato',
  'moneyIn.voucher.labourAgreement': 'Labour agreement',
  'moneyIn.voucher.lastPayment': 'Last payment',
  'moneyIn.voucher.latestContributionPaymentBegin':
    'Latest contribution payment begin',
  'moneyIn.voucher.latestContributionPaymentEnd':
    'Latest contribution payment end',
  'moneyIn.voucher.latestPayment': 'Latest payment',
  'moneyIn.voucher.leaveCoverage': 'Leave coverage',
  'moneyIn.voucher.leaveHoursInTimeSlot': 'Leave hours in time slot',
  'moneyIn.voucher.leaveInformation': 'Leave information',
  'moneyIn.voucher.leavePercentage': 'Leave percentage',
  'moneyIn.voucher.leaves': 'Leaves',
  'moneyIn.voucher.levDto': 'Lev dto',
  'moneyIn.voucher.levNr': 'Lev nr',
  'moneyIn.voucher.limitedWidowsPensionDate': 'Limited widows pension date',
  'moneyIn.voucher.lonTrinNr': 'Lon trin nr',
  'moneyIn.voucher.lonTrinStartDto': 'Lon trin start dto',
  'moneyIn.voucher.mandateId': 'Mandate id',
  'moneyIn.voucher.mandateIdentification': 'Mandate identification',
  'moneyIn.voucher.mandateSignatureDate': 'Mandate signature date',
  'moneyIn.voucher.manual': 'Manual',
  'moneyIn.voucher.manualInvoice': 'Manual invoice',
  'moneyIn.voucher.manualInvoiceDetail': 'Manual invoice detail',
  'moneyIn.voucher.manualInvoiceType': 'Manual invoice type',
  'moneyIn.voucher.maritalValue': 'Marital value',
  'moneyIn.voucher.merchantId': 'Merchant id',
  'moneyIn.voucher.merchantNo': 'Merchant no',
  'moneyIn.voucher.message': 'Message',
  'moneyIn.voucher.messageId': 'Message id',
  'moneyIn.voucher.messageReasonCodTxt': 'Message reason cod txt',
  'moneyIn.voucher.messageText': 'Message text',
  'moneyIn.voucher.messageTypeId': 'Message type id',
  'moneyIn.voucher.messageValidationResult': 'Message validation result',
  'moneyIn.voucher.migratedInvoice': 'Migrated invoice',
  'moneyIn.voucher.modtAfdNr': 'Modt afd nr',
  'moneyIn.voucher.modtPbsNr': 'Modt pbs nr',
  'moneyIn.voucher.multilangTxtShrt': 'Multilang txt shrt',
  'moneyIn.voucher.naturalPerson': 'Natural person',
  'moneyIn.voucher.negativeUnusedPALTax': 'Negative unused paltax',
  'moneyIn.voucher.netAmountPaid': 'Net amount paid',
  'moneyIn.voucher.netAxeptBatch': 'Net axept batch',
  'moneyIn.voucher.netsTransId': 'Nets trans id',
  'moneyIn.voucher.newSalaryDate': 'New salary date',
  'moneyIn.voucher.nlPremiumComponents': 'Premium components',
  'moneyIn.voucher.nlValueTransferPartnerStatements':
    'Value transfer partner statements',
  'moneyIn.voucher.noOfContributionsWithPeriodStartAtOrAfterPaymentDate':
    'No of contributions with period start at or after payment date',
  'moneyIn.voucher.noOfContributionsWithPeriodStartBeforePaymentDate':
    'No of contributions with period start before payment date',
  'moneyIn.voucher.noOfEmployerToEmployeeContributionBlocks':
    'No of employer to employee contribution blocks',
  'moneyIn.voucher.noOfEmployers': 'No of employers',
  'moneyIn.voucher.noOfRecords': 'No of records',
  'moneyIn.voucher.noOfRegulationsWithEarlyPeriodStart':
    'No of regulations with early period start',
  'moneyIn.voucher.nominalAnnualFullTimeSalary':
    'Nominal annual full time salary',
  'moneyIn.voucher.nominalPartTimePercentage': 'Nominal part time percentage',
  'moneyIn.voucher.normBidrag': 'Norm bidrag',
  'moneyIn.voucher.normBidragBlb': 'Norm bidrag blb',
  'moneyIn.voucher.normBidragStartDto': 'Norm bidrag start dto',
  'moneyIn.voucher.normHoursInPeriod': 'Norm hours in period',
  'moneyIn.voucher.normHoursInPeriodLeave': 'Norm hours in period leave',
  'moneyIn.voucher.normHoursPerWeek': 'Norm hours per week',
  'moneyIn.voucher.normHoursWeekly': 'Norm hours weekly',
  'moneyIn.voucher.numRecs': 'Num recs',
  'moneyIn.voucher.numberOfInsured': 'Number of insured',
  'moneyIn.voucher.numberOfPaidHours': 'Number of paid hours',
  'moneyIn.voucher.numberOfTrans': 'Number of trans',
  'moneyIn.voucher.numberOfUnits': 'Number of units',
  'moneyIn.voucher.onCallAgreementIndication': 'On call agreement indication',
  'moneyIn.voucher.ongoingAgeScheme': 'Ongoing age scheme',
  'moneyIn.voucher.ongoingInstalmentPensionPayments':
    'Ongoing instalment pension payments',
  'moneyIn.voucher.ongoingStoppingAnnuityPayments':
    'Ongoing stopping annuity payments',
  'moneyIn.voucher.origDateTimeTrn': 'Orig date time trn',
  'moneyIn.voucher.originId': 'Origin id',
  'moneyIn.voucher.originType': 'Origin type',
  'moneyIn.voucher.originVoucherRef': 'Origin voucher ref',
  'moneyIn.voucher.originalAmount': 'Original amount',
  'moneyIn.voucher.originalDueDate': 'Original due date',
  'moneyIn.voucher.originalPaymentDate': 'Original payment date',
  'moneyIn.voucher.originalPostingId': 'Original posting id',
  'moneyIn.voucher.originalRef': 'Original ref',
  'moneyIn.voucher.outgoingBillingSpecification':
    'Outgoing billing specification',
  'moneyIn.voucher.outstandingAmount': 'Outstanding amount',
  'moneyIn.voucher.overenskomstnr': 'Overenskomstnr',
  'moneyIn.voucher.ownedRecords': 'Owned records',
  'moneyIn.voucher.ownerId': 'Owner id',
  'moneyIn.voucher.p41AmountItems': 'P41 amount items',
  'moneyIn.voucher.p41BankAccount': 'P41 bank account',
  'moneyIn.voucher.p41BankDataCommon': 'P41 bank data common',
  'moneyIn.voucher.p41BankPaymentInformation': 'P41 bank payment information',
  'moneyIn.voucher.p41ContactPerson': 'P41 contact person',
  'moneyIn.voucher.p41InterestCalculations': 'P41 interest calculations',
  'moneyIn.voucher.p41OngoingAgeSchemePayments':
    'P41 ongoing age scheme payments',
  'moneyIn.voucher.p41OngoingInstalmentPensionPayments':
    'P41 ongoing instalment pension payments',
  'moneyIn.voucher.p41OngoingLifetimeAnnuityPayments':
    'P41 ongoing lifetime annuity payments',
  'moneyIn.voucher.p41OngoingStoppingAnnuityPayments':
    'P41 ongoing stopping annuity payments',
  'moneyIn.voucher.p41PaymentAgeType': 'P41 payment age type',
  'moneyIn.voucher.p41PaymentFrequency': 'P41 payment frequency',
  'moneyIn.voucher.p41PaymentInformation': 'P41 payment information',
  'moneyIn.voucher.p41PaymentSpecVoucherRef': 'P41 payment spec voucher ref',
  'moneyIn.voucher.p41PensionPALTax': 'P41 pension paltax',
  'moneyIn.voucher.p41PensionPaymentInformation':
    'P41 pension payment information',
  'moneyIn.voucher.p41PensionTransferDatas': 'P41 pension transfer datas',
  'moneyIn.voucher.p41TaxCode': 'P41 tax code',
  'moneyIn.voucher.p41TaxPeriode': 'P41 tax periode',
  'moneyIn.voucher.p41Transfer': 'P41 transfer',
  'moneyIn.voucher.pALTaxPayedOngoingAgeScheme_Bank':
    'Paltax payed ongoing age scheme_bank',
  'moneyIn.voucher.paidHoursInTimeSlot': 'Paid hours in time slot',
  'moneyIn.voucher.palTax': 'Pal tax',
  'moneyIn.voucher.palTax32Period': 'Pal tax32 period',
  'moneyIn.voucher.palTaxExemptionDate': 'Pal tax exemption date',
  'moneyIn.voucher.palTaxPeriod': 'Pal tax period',
  'moneyIn.voucher.palTaxPeriodPayed': 'Pal tax period payed',
  'moneyIn.voucher.palTaxPeriodUnusedNegative':
    'Pal tax period unused negative',
  'moneyIn.voucher.palTaxPeriodYear': 'Pal tax period year',
  'moneyIn.voucher.panVar': 'Pan var',
  'moneyIn.voucher.parentPaymentId': 'Parent payment id',
  'moneyIn.voucher.partialInterestAmount_Bank': 'Partial interest amount_bank',
  'moneyIn.voucher.partialPaymentTotal_Bank': 'Partial payment total_bank',
  'moneyIn.voucher.partialReceiver': 'Partial receiver',
  'moneyIn.voucher.partialSender': 'Partial sender',
  'moneyIn.voucher.partialTransferAgeSchemeAmount':
    'Partial transfer age scheme amount',
  'moneyIn.voucher.partialTransferAgeSchemeTaxFree':
    'Partial transfer age scheme tax free',
  'moneyIn.voucher.partialTransferAgeSchemeTaxfree':
    'Partial transfer age scheme taxfree',
  'moneyIn.voucher.partialTransferAmount': 'Partial transfer amount',
  'moneyIn.voucher.partialTransferLifeTimeAnnuity':
    'Partial transfer life time annuity',
  'moneyIn.voucher.partialTransferLifetimeAnnuity':
    'Partial transfer lifetime annuity',
  'moneyIn.voucher.partialTransferTaxCode1': 'Partial transfer tax code1',
  'moneyIn.voucher.partialTransferTaxCode1Amount':
    'Partial transfer tax code1 amount',
  'moneyIn.voucher.partialTransferTaxCode2': 'Partial transfer tax code2',
  'moneyIn.voucher.partialTransferTaxCode2Amount':
    'Partial transfer tax code2 amount',
  'moneyIn.voucher.partialTransferTaxCode3': 'Partial transfer tax code3',
  'moneyIn.voucher.partialTransferTaxCode3Amount':
    'Partial transfer tax code3 amount',
  'moneyIn.voucher.participant': 'Participant',
  'moneyIn.voucher.participantId': 'Participant id',
  'moneyIn.voucher.parttimePct': 'Parttime pct',
  'moneyIn.voucher.parttimePercentage': 'Parttime percentage',
  'moneyIn.voucher.payInCash': 'Pay in cash',
  'moneyIn.voucher.payableId': 'Payable id',
  'moneyIn.voucher.payer': 'Payer',
  'moneyIn.voucher.payerId': 'Payer id',
  'moneyIn.voucher.payerLegalEntityId': 'Payer legal entity id',
  'moneyIn.voucher.payerRef': 'Payer ref',
  'moneyIn.voucher.payingCompany': 'Paying company',
  'moneyIn.voucher.payment': 'Payment',
  'moneyIn.voucher.paymentAge': 'Payment age',
  'moneyIn.voucher.paymentBasis': 'Payment basis',
  'moneyIn.voucher.paymentDate': 'Payment date',
  'moneyIn.voucher.paymentEndDate': 'Payment end date',
  'moneyIn.voucher.paymentEntryRef': 'Payment entry ref',
  'moneyIn.voucher.paymentFrequency': 'Payment frequency',
  'moneyIn.voucher.paymentId': 'Payment id',
  'moneyIn.voucher.paymentInterest': 'Payment interest',
  'moneyIn.voucher.paymentMethod': 'Payment method',
  'moneyIn.voucher.paymentOrigin': 'Payment origin',
  'moneyIn.voucher.paymentPeriodEnd': 'Payment period end',
  'moneyIn.voucher.paymentPeriodFrom': 'Payment period from',
  'moneyIn.voucher.paymentPeriodStart': 'Payment period start',
  'moneyIn.voucher.paymentPeriodTo': 'Payment period to',
  'moneyIn.voucher.paymentReceiverType': 'Payment receiver type',
  'moneyIn.voucher.paymentReferences': 'Payment references',
  'moneyIn.voucher.paymentRemark': 'Payment remark',
  'moneyIn.voucher.paymentSender': 'Payment sender',
  'moneyIn.voucher.paymentSpecOrigin': 'Payment spec origin',
  'moneyIn.voucher.paymentSpecVoucherRef': 'Payment spec voucher ref',
  'moneyIn.voucher.paymentStartDate': 'Payment start date',
  'moneyIn.voucher.paymentTotal': 'Payment total',
  'moneyIn.voucher.paymentType': 'Payment type',
  'moneyIn.voucher.paymentWithoutInterest': 'Payment without interest',
  'moneyIn.voucher.paymentWithoutPALandInterest':
    'Payment without paland interest',
  'moneyIn.voucher.pblLimit': 'Pbl limit',
  'moneyIn.voucher.pekoInvoiceDetails': 'Peko invoice details',
  'moneyIn.voucher.penaltyId': 'Penalty id',
  'moneyIn.voucher.pensAlderKod': 'Pens alder kod',
  'moneyIn.voucher.pensBidragPct': 'Pens bidrag pct',
  'moneyIn.voucher.pensBidragPctStartDto': 'Pens bidrag pct start dto',
  'moneyIn.voucher.pensType': 'Pens type',
  'moneyIn.voucher.pensionAccountToTransfer': 'Pension account to transfer',
  'moneyIn.voucher.pensionScheme': 'Pension scheme',
  'moneyIn.voucher.pensionableSalary': 'Pensionable salary',
  'moneyIn.voucher.percentLeave': 'Percent leave',
  'moneyIn.voucher.percentage': 'Percentage',
  'moneyIn.voucher.period': 'Period',
  'moneyIn.voucher.periodEnd': 'Period end',
  'moneyIn.voucher.periodFullSalaryLeave': 'Period full salary leave',
  'moneyIn.voucher.periodNonStructuralSalary': 'Period non structural salary',
  'moneyIn.voucher.periodSalary': 'Period salary',
  'moneyIn.voucher.periodStart': 'Period start',
  'moneyIn.voucher.personDataValidationStatus': 'Person data validation status',
  'moneyIn.voucher.personId': 'Person id',
  'moneyIn.voucher.personRef': 'Person ref',
  'moneyIn.voucher.personSpecVouchersForRemoval':
    'Person spec vouchers for removal',
  'moneyIn.voucher.personnelNumber': 'Personnel number',
  'moneyIn.voucher.policyDescription': 'Policy description',
  'moneyIn.voucher.policyHolder': 'Policy holder',
  'moneyIn.voucher.policyInternalTemplateId': 'Policy internal template id',
  'moneyIn.voucher.policyKey': 'Policy key',
  'moneyIn.voucher.policyNumber': 'Policy number',
  'moneyIn.voucher.policyToTransfer': 'Policy to transfer',
  'moneyIn.voucher.postingText': 'Posting text',
  'moneyIn.voucher.postingType': 'Posting type',
  'moneyIn.voucher.premiumBase': 'Premium base',
  'moneyIn.voucher.premiumBasis': 'Premium basis',
  'moneyIn.voucher.premiumEmployee': 'Premium employee',
  'moneyIn.voucher.premiumFromDueDate': 'Premium from due date',
  'moneyIn.voucher.premiumInvoiceDetail': 'Premium invoice detail',
  'moneyIn.voucher.premiumInvoiceDetails': 'Premium invoice details',
  'moneyIn.voucher.premiumTotal': 'Premium total',
  'moneyIn.voucher.previousInvoiceIds': 'Previous invoice ids',
  'moneyIn.voucher.priority': 'Priority',
  'moneyIn.voucher.processId': 'Process id',
  'moneyIn.voucher.processingPeriodStart': 'Processing period start',
  'moneyIn.voucher.providerCVR': 'Provider cvr',
  'moneyIn.voucher.publicLawAppointmentForIndefinitePeriod':
    'Public law appointment for indefinite period',
  'moneyIn.voucher.rawLine': 'Raw line',
  'moneyIn.voucher.rec1Reserve1Txt': 'Rec1 reserve1 txt',
  'moneyIn.voucher.rec3Reserve1Txt': 'Rec3 reserve1 txt',
  'moneyIn.voucher.rec4Reserve1Txt': 'Rec4 reserve1 txt',
  'moneyIn.voucher.recTypeId': 'Rec type id',
  'moneyIn.voucher.receiverId': 'Receiver id',
  'moneyIn.voucher.receiverPBSNumber': 'Receiver pbsnumber',
  'moneyIn.voucher.receivingAccount': 'Receiving account',
  'moneyIn.voucher.receivingCompany': 'Receiving company',
  'moneyIn.voucher.receivingCompanyId': 'Receiving company id',
  'moneyIn.voucher.receivingCompanyType': 'Receiving company type',
  'moneyIn.voucher.receivingDate': 'Receiving date',
  'moneyIn.voucher.receivingFundId': 'Receiving fund id',
  'moneyIn.voucher.recipientAccountId': 'Recipient account id',
  'moneyIn.voucher.recipientCustomerId': 'Recipient customer id',
  'moneyIn.voucher.recipientOwnDepartmentId': 'Recipient own department id',
  'moneyIn.voucher.reconcileInfo': 'Reconcile info',
  'moneyIn.voucher.reconcileNote': 'Reconcile note',
  'moneyIn.voucher.reconcileValueDate': 'Reconcile value date',
  'moneyIn.voucher.reconciledPaymentDate': 'Reconciled payment date',
  'moneyIn.voucher.recurring': 'Recurring',
  'moneyIn.voucher.reductionDueToForeignTax': 'Reduction due to foreign tax',
  'moneyIn.voucher.reference': 'Reference',
  'moneyIn.voucher.regulationType': 'Regulation type',
  'moneyIn.voucher.relatedLegalEntityId': 'Related legal entity id',
  'moneyIn.voucher.relatedPersonId': 'Related person id',
  'moneyIn.voucher.relationshipId': 'Relationship id',
  'moneyIn.voucher.relationshipNumber': 'Relationship number',
  'moneyIn.voucher.remark': 'Remark',
  'moneyIn.voucher.remarkFreeText': 'Remark free text',
  'moneyIn.voucher.remunerationPeriod': 'Remuneration period',
  'moneyIn.voucher.remunerationPeriodMetrics': 'Remuneration period metrics',
  'moneyIn.voucher.repurchase': 'Repurchase',
  'moneyIn.voucher.repurchaseClause': 'Repurchase clause',
  'moneyIn.voucher.repurchaseClauseText': 'Repurchase clause text',
  'moneyIn.voucher.requestDate': 'Request date',
  'moneyIn.voucher.requestedDueDate': 'Requested due date',
  'moneyIn.voucher.resignationDate': 'Resignation date',
  'moneyIn.voucher.responseDateTime': 'Response date time',
  'moneyIn.voucher.retrievalReqNbr': 'Retrieval req nbr',
  'moneyIn.voucher.retrievedEmploymentTermsAmount':
    'Retrieved employment terms amount',
  'moneyIn.voucher.returnAutomatically': 'Return automatically',
  'moneyIn.voucher.returnInformation': 'Return information',
  'moneyIn.voucher.returnPaymentInfos': 'Return payment infos',
  'moneyIn.voucher.returnPaymentInvoiceId': 'Return payment invoice id',
  'moneyIn.voucher.returnReason': 'Return reason',
  'moneyIn.voucher.returnedPaymentPayableId': 'Returned payment payable id',
  'moneyIn.voucher.reversalIndicator': 'Reversal indicator',
  'moneyIn.voucher.routingSource': 'Routing source',
  'moneyIn.voucher.routingTarget': 'Routing target',
  'moneyIn.voucher.salary': 'Salary',
  'moneyIn.voucher.salaryDetails': 'Salary details',
  'moneyIn.voucher.salaryFromDate': 'Salary from date',
  'moneyIn.voucher.salaryInArrears': 'Salary in arrears',
  'moneyIn.voucher.salaryInPeriod': 'Salary in period',
  'moneyIn.voucher.salaryInformation': 'Salary information',
  'moneyIn.voucher.salaryLastChangedDate': 'Salary last changed date',
  'moneyIn.voucher.salaryLevel': 'Salary level',
  'moneyIn.voucher.salaryPartTimePct': 'Salary part time pct',
  'moneyIn.voucher.salaryPeriodCancelled': 'Salary period cancelled',
  'moneyIn.voucher.salaryPeriodEnd': 'Salary period end',
  'moneyIn.voucher.salaryPeriodStart': 'Salary period start',
  'moneyIn.voucher.salaryToDate': 'Salary to date',
  'moneyIn.voucher.salaryType': 'Salary type',
  'moneyIn.voucher.schemeDatas': 'Scheme datas',
  'moneyIn.voucher.schemeId': 'Scheme id',
  'moneyIn.voucher.schemeVariant': 'Scheme variant',
  'moneyIn.voucher.schemeWage': 'Scheme wage',
  'moneyIn.voucher.sectionNumber': 'Section number',
  'moneyIn.voucher.sector': 'Sector',
  'moneyIn.voucher.sectors': 'Sectors',
  'moneyIn.voucher.senderAccount': 'Sender account',
  'moneyIn.voucher.senderAccountNumber': 'Sender account number',
  'moneyIn.voucher.senderCVR': 'Sender cvr',
  'moneyIn.voucher.senderCustomerRef': 'Sender customer ref',
  'moneyIn.voucher.seniorityFromDate': 'Seniority from date',
  'moneyIn.voucher.sentDateTime': 'Sent date time',
  'moneyIn.voucher.sequence': 'Sequence',
  'moneyIn.voucher.sequenceNumber': 'Sequence number',
  'moneyIn.voucher.settFkMedlemdsNr': 'Sett fk medlemds nr',
  'moneyIn.voucher.settFkMedlemsNr': 'Sett fk medlems nr',
  'moneyIn.voucher.settleDate': 'Settle date',
  'moneyIn.voucher.settlementFraction': 'Settlement fraction',
  'moneyIn.voucher.severity': 'Severity',
  'moneyIn.voucher.signingDate': 'Signing date',
  'moneyIn.voucher.skipFurtherAutoCorrection': 'Skip further auto correction',
  'moneyIn.voucher.sourceRef': 'Source ref',
  'moneyIn.voucher.sourceReference': 'Source reference',
  'moneyIn.voucher.spec': 'Spec',
  'moneyIn.voucher.specialCircumstances': 'Special circumstances',
  'moneyIn.voucher.specialPaymentRules': 'Special payment rules',
  'moneyIn.voucher.specificationCreationDate': 'Specification creation date',
  'moneyIn.voucher.specificationEndDate': 'Specification end date',
  'moneyIn.voucher.specificationLineId': 'Specification line id',
  'moneyIn.voucher.specificationNumber': 'Specification number',
  'moneyIn.voucher.specificationStartDate': 'Specification start date',
  'moneyIn.voucher.specifiedAmount': 'Specified amount',
  'moneyIn.voucher.spouseIdentity': 'Spouse identity',
  'moneyIn.voucher.spousePension': 'Spouse pension',
  'moneyIn.voucher.spousePensionAmount': 'Spouse pension amount',
  'moneyIn.voucher.spousePensionDate': 'Spouse pension date',
  'moneyIn.voucher.spousePensionPeriod': 'Spouse pension period',
  'moneyIn.voucher.stamp': 'Stamp',
  'moneyIn.voucher.startDate': 'Start date',
  'moneyIn.voucher.startDateIncomePeriod': 'Start date income period',
  'moneyIn.voucher.stoppingPensionPBL15A': 'Stopping pension pbl15 a',
  'moneyIn.voucher.subIssues': 'Sub issues',
  'moneyIn.voucher.sumPaymentTaxCode1and2TransferYear':
    'Sum payment tax code1and2 transfer year',
  'moneyIn.voucher.sumPaymentTaxfreeAgeSchemeTransferYear':
    'Sum payment taxfree age scheme transfer year',
  'moneyIn.voucher.sumReturnsAverageInterestRate':
    'Sum returns average interest rate',
  'moneyIn.voucher.sumReturnsMarketInterestRate':
    'Sum returns market interest rate',
  'moneyIn.voucher.sumReturnsOngoingAgeScheme_Bank':
    'Sum returns ongoing age scheme_bank',
  'moneyIn.voucher.sumReturnsTransferYear': 'Sum returns transfer year',
  'moneyIn.voucher.sumReturnsTransferYearPension':
    'Sum returns transfer year pension',
  'moneyIn.voucher.sumStopPaymentsAnnuityInstalment':
    'Sum stop payments annuity instalment',
  'moneyIn.voucher.sumTaxfreeSinglePayment': 'Sum taxfree single payment',
  'moneyIn.voucher.summaryDate': 'Summary date',
  'moneyIn.voucher.supplementalAmountEntity': 'Supplemental amount entity',
  'moneyIn.voucher.supplierId': 'Supplier id',
  'moneyIn.voucher.suspensionDate': 'Suspension date',
  'moneyIn.voucher.suspensionReason': 'Suspension reason',
  'moneyIn.voucher.systemCode': 'System code',
  'moneyIn.voucher.table.otherDetails': 'Other details',
  'moneyIn.voucher.table.value': 'Value',
  'moneyIn.voucher.targetId': 'Target id',
  'moneyIn.voucher.taskNumber': 'Task number',
  'moneyIn.voucher.taxCode1ValuePayedToCustomer':
    'Tax code1 value payed to customer',
  'moneyIn.voucher.taxInformation': 'Tax information',
  'moneyIn.voucher.telephoneNumber': 'Telephone number',
  'moneyIn.voucher.template': 'Template',
  'moneyIn.voucher.tenantId': 'Tenant id',
  'moneyIn.voucher.terminalOpeMeNo': 'Terminal ope me no',
  'moneyIn.voucher.timeSlotEndDate': 'Time slot end date',
  'moneyIn.voucher.timeSlotStartDate': 'Time slot start date',
  'moneyIn.voucher.toDate': 'To date',
  'moneyIn.voucher.toDueDate': 'To due date',
  'moneyIn.voucher.totalAmount': 'Total amount',
  'moneyIn.voucher.totalAmountInFile': 'Total amount in file',
  'moneyIn.voucher.totalContributionPercentage':
    'Total contribution percentage',
  'moneyIn.voucher.totalNoOfContributions': 'Total no of contributions',
  'moneyIn.voucher.traceId': 'Trace id',
  'moneyIn.voucher.transTypeCode': 'Trans type code',
  'moneyIn.voucher.transactionType': 'Transaction type',
  'moneyIn.voucher.transactions': 'Transactions',
  'moneyIn.voucher.transactionsNo': 'Transactions no',
  'moneyIn.voucher.transferAgeSchemeTaxFree': 'Transfer age scheme tax free',
  'moneyIn.voucher.transferData': 'Transfer data',
  'moneyIn.voucher.transferDataNumber': 'Transfer data number',
  'moneyIn.voucher.transferDate': 'Transfer date',
  'moneyIn.voucher.transferOngoingInstalmentPension':
    'Transfer ongoing instalment pension',
  'moneyIn.voucher.transferStoppingOngoingAnnuity':
    'Transfer stopping ongoing annuity',
  'moneyIn.voucher.transferTaxCode1': 'Transfer tax code1',
  'moneyIn.voucher.transferTaxCode2': 'Transfer tax code2',
  'moneyIn.voucher.transferTaxCode3': 'Transfer tax code3',
  'moneyIn.voucher.transferredIn': 'Transferred in',
  'moneyIn.voucher.transferringFundId': 'Transferring fund id',
  'moneyIn.voucher.twkInvoice': 'Twk invoice',
  'moneyIn.voucher.txtRecvAcctStm': 'Txt recv acct stm',
  'moneyIn.voucher.typeOfPension': 'Type of pension',
  'moneyIn.voucher.typeOfTransfer': 'Type of transfer',
  'moneyIn.voucher.unexpectedInvoicePaymentType':
    'Unexpected invoice payment type',
  'moneyIn.voucher.uniqueNtryRef': 'Unique ntry ref',
  'moneyIn.voucher.uniqueStmtId': 'Unique stmt id',
  'moneyIn.voucher.unparseableRecord04': 'Unparseable record04',
  'moneyIn.voucher.unparseableValues': 'Unparseable values',
  'moneyIn.voucher.unrelatedPaymentType': 'Unrelated payment type',
  'moneyIn.voucher.unusedNegativePALOngoingAgeScheme_Bank':
    'Unused negative palongoing age scheme_bank',
  'moneyIn.voucher.upaDeclarationType': 'Upa declaration type',
  'moneyIn.voucher.upaIncomeRelation': 'Upa income relation',
  'moneyIn.voucher.upaIncomeRelationVoucherRef':
    'Upa income relation voucher ref',
  'moneyIn.voucher.upaProcessingResult': 'Upa processing result',
  'moneyIn.voucher.upaSchemeId': 'Upa scheme id',
  'moneyIn.voucher.upaTimeSlotDeclarationType':
    'Upa time slot declaration type',
  'moneyIn.voucher.upaTimeSlotType': 'Upa time slot type',
  'moneyIn.voucher.upaXmlSchemaVersion': 'Upa xml schema version',
  'moneyIn.voucher.upcomingReturnPaymentPostingId':
    'Upcoming return payment posting id',
  'moneyIn.voucher.usedDefaultEmployerAgreementPolicy':
    'Used default employer agreement policy',
  'moneyIn.voucher.usedSoftwarePackage': 'Used software package',
  'moneyIn.voucher.userId': 'User id',
  'moneyIn.voucher.usesProjectedData': 'Uses projected data',
  'moneyIn.voucher.validationErrorIssues': 'Validation error issues',
  'moneyIn.voucher.validationResult': 'Validation result',
  'moneyIn.voucher.value79Before72': 'Value79 before72',
  'moneyIn.voucher.value79From72To79': 'Value79 from72 to79',
  'moneyIn.voucher.value82': 'Value82',
  'moneyIn.voucher.valueFromPayload': 'Value from payload',
  'moneyIn.voucher.valueTransferId': 'Value transfer id',
  'moneyIn.voucher.valueTransferStatement': 'Value transfer statement',
  'moneyIn.voucher.valueTransferType': 'Value transfer type',
  'moneyIn.voucher.valueTransfered': 'Value transfered',
  'moneyIn.voucher.voluntaryContributionPlacement':
    'Voluntary contribution placement',
  'moneyIn.voucher.voluntaryContributionPolicyId':
    'Voluntary contribution policy id',
  'moneyIn.voucher.voluntaryContributionType': 'Voluntary contribution type',
  'moneyIn.voucher.voucherFieldName': 'Voucher field name',
  'moneyIn.voucher.voucherVersionSequenceNumber':
    'Voucher version sequence number',
  'moneyIn.voucher.wageFromOvertime': 'Wage from overtime',
  'moneyIn.voucher.wageTaxTableCode': 'Wage tax table code',
  'moneyIn.voucher.wagesLBPH': 'Wages lbph',
  'moneyIn.voucher.wagesSV': 'Wages sv',
  'moneyIn.voucher.wagesTaxedSpecialRenumerationTable':
    'Wages taxed special renumeration table',
  'moneyIn.voucher.warningCodes': 'Warning codes',
  'moneyIn.voucher.warnings': 'Warnings',
  'moneyIn.voucher.widowIdentity': 'Widow identity',
  'moneyIn.voucher.withdrawPaymentCommandId': 'Withdraw payment command id',
  'moneyIn.voucher.withdrawalDate': 'Withdrawal date',
  'moneyIn.voucher.withdrawnPenaltyId': 'Withdrawn penalty id',
  'moneyIn.voucher.withholdPALTax': 'Withhold paltax',
  'moneyIn.voucher.withholdPALTaxTransferYear': 'Withhold paltax transfer year',
  'moneyIn.voucher.workHours': 'Work hours',
  'moneyIn.voucher.workHoursInPeriod': 'Work hours in period',
  'moneyIn.voucher.workflowRef': 'Workflow ref',
  'moneyIn.voucher.writeOffCategory': 'Write off category',
  'moneyIn.voucher.writeOffType': 'Write off type',
  'moneyIn.voucher.yearOldestUnusedPALTax': 'Year oldest unused paltax',
} as const
